<template>
    <Dialog
        :is-popup="isOpen"
        @close="close"
        :scrollable="false"
    >
        <div
            class="activity-decline-popup"
             v-if="item">
                <h1>
                    Отмена встречи
                </h1>
                <div class="header">
                    <div class="left">
                        <div
                            class="avatar"
                            :style="item.initiatorAvatar ? { backgroundImage: `url(${item.initiatorAvatar})`} : {}"
                        ></div>
                        <div class="title">
                            <div class="pair-name">
                                {{ pairFullName }}
                            </div>
                            предлагает встречу
                        </div>
                    </div>
                    <div>
                        <div class="date">
                            <span class="time">{{ item.datetime | timestampTime(true) }}</span>
                            {{ item.datetime | timestampFullDate(false, true) }}
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="theme">
                        {{ item.theme }}
                    </div>
                    <div class="description">
                        {{ item.description }}
                    </div>
                    <div class="location">
                        {{ item.location }}
                    </div>
                </div>
                <ModelTextArea
                    label="Причина отмены"
                    v-model="rejection_reason"
                />
                <Button
                    class="btn"
                    @click="save"
                >
                    Отправить
                </Button>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '../../../../UI/Dialog';
import Button from '../../../../UI/Button';
import ModelTextArea from '../../../../UI/models/ModelTextArea';
import {mapActions, mapGetters, mapState} from 'vuex';
import {ActivityStatus, ActivityType} from '@/stores/mentoring/activities';

export default {
    name: 'MeetingDecline',
    props: {
        activityId: {
            type: Number,
            required: false,
        },
    },
    data: () => ({
        item: null,
        loading: false,
        rejection_reason: '',
    }),
    components: {
        Dialog,
        Button,
        ModelTextArea,
    },
    watch: {
        activityId() {
            this.syncActivity();
        },
    },
    mounted() {
        this.syncActivity();
    },
    computed: {
        ...mapGetters('mentoring/activities', [
            'getActivity',
        ]),
        ...mapState('mentoring', [
            'pair',
            'role',
        ]),
        isOpen: {
            get() {
                return this.item !== null;
            },
            set() {
                this.close();
            },
        },
        pairFullName() {
            if (!this.pair) return '';
            return `${this.pair.surname} ${this.pair.name}`;
        },
    },
    methods: {
        ...mapActions('mentoring/activities', [
            'rejectMeeting',
        ]),
        close() {
            this.rejection_reason = '';
            this.$emit('close');
        },
        async save() {
            this.loading = true;
            await this.rejectMeeting({
                meeting_id: this.item.id,
                rejection_reason: this.rejection_reason,
            });
            this.close();
        },
        syncActivity() {
            this.item = this.getActivity({ id: this.activityId, type: ActivityType.meeting });
            this.changingStatus = false;
        },
    },
};
</script>

<style lang="scss">
    @import '../../../../../styles/rem';

    .activity-decline-popup {
        width: rem(538);

        @include on-mobile {
            width: 100%;
        }

        h1 {
            font-style: normal;
            font-size: rem(24);
            line-height: rem(32);
            text-align: center;
            color: #2A2626;
            margin-top: 0;

            @include on-mobile {
                font-size: mrem(24);
                line-height: mrem(32);
            }
        }

        .header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            @include on-mobile {
                flex-wrap: wrap;
            }

            .left {
                display: flex;
                flex-direction: row;

                @include on-mobile {
                    flex-direction: row-reverse;
                    justify-content: space-between;
                    width: 100%;
                    margin-bottom: mrem(8);
                }

                .title {
                    font-size: rem(14);
                    line-height: rem(20);
                    color: #8F9398;
                    margin-left: rem(16);

                    @include on-mobile {
                        margin-left: 0;
                        font-size: mrem(14);
                        line-height: mrem(20);
                    }
                }
            }
            margin-bottom: rem(16);

            @include on-mobile {
                margin-bottom: mrem(16);
            }
        }
        .pair-name {
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            color: #3AA0FD;
            margin-bottom: rem(4);

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
                margin-bottom: mrem(4);
            }
        }

        .avatar {
            height: rem(32);
            width: rem(32);
            border-radius: rem(32);
            background-image: url("../../../../../assets/images/avatar_placeholder.png");
            background-size: contain;
            background-repeat: no-repeat;

            @include on-mobile {
                height: mrem(32);
                width: mrem(32);
                border-radius: mrem(32);
            }
        }

        .date {
            width: 100%;
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            margin-bottom: rem(8);
            color: #3AA0FD;

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
                margin-bottom: 0;
            }
        }

        .theme {
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #000000;
            margin-bottom: rem(8);

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
                margin-bottom: mrem(8);
            }
        }
        .description,
        .location {
            font-size: rem(16);
            line-height: rem(24);
            color: #000000;
            margin-bottom: rem(8);

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
                margin-bottom: mrem(8);
            }
        }
        .btn {
            width: rem(257);
            border-radius: rem(4);

            @include on-mobile {
                width: 100%;
                border-radius: mrem(4);
            }
        }
    }
</style>

<style lang="scss" scoped>

</style>